module.exports = __webpack_public_path__ + "img/logo-sonphat.37b06126.png";